import { tabClasses } from "@mui/material/Tab";
// ----------------------------------------------------------------------
export function tabs(theme) {
    return {
        MuiTabs: {
            styleOverrides: {
                root: {
                    minHeight: "auto",
                },
                indicator: {
                    display: "none", // Hide the default indicator
                },
                scrollButtons: {
                    width: 48,
                    borderRadius: "50%",
                },
                flexContainer: {
                    gap: theme.spacing(1), // 8px gap between tabs
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minWidth: "auto",
                    minHeight: "auto",
                    padding: "8px 12px",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "22px",
                    textTransform: "none",
                    borderRadius: "500px", // Pill shape
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.background.neutral,
                    transition: "all 0.3s ease",
                    opacity: 1,
                    "&:hover": {
                        backgroundColor: theme.palette.action.hover,
                    },
                    "&.Mui-selected": {
                        backgroundColor: "#012751", // Dark blue background for selected tab
                        color: theme.palette.common.white,
                        fontWeight: 400,
                        "&:hover": {
                            backgroundColor: "#012751",
                        },
                    },
                    "&:not(:last-of-type)": {
                        marginRight: 0, // Remove margin, using gap instead
                    },
                    [`&:not(.${tabClasses.selected})`]: {
                        color: theme.palette.text.primary,
                    },
                },
            },
        },
    };
}
